import { FirebaseError } from 'firebase/app';
import { collection, getDocs } from 'firebase/firestore';

import { db } from '../../config';

export const fetchDocumentsFromCollection = async <T>(
  collectionPath: string,
): Promise<T[]> => {
  try {
    const collectionRef = collection(db, collectionPath);
    const snapshot = await getDocs(collectionRef);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as unknown as T[];
  } catch (error) {
    throw new FirebaseError('failed-to-fetch', 'Error fetching collection');
  }
};
